<section>
  <h4>Welcome {{ user()?.payload?.first_name }}!</h4>

  <p>Where do you want to go</p>

  <ul>
    <li><a routerLink="/admin-create-school">Add a School</a></li>
    <li><a routerLink="/signup">Add a School Administrator</a></li>
    <li><a routerLink="/dashboard">Visit your Dashboard</a></li>
  </ul>
</section>
